import React, { useEffect, useState, useRef } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import LocationSelect from "../../location-select"

import "./style.less"

const locationRoutes = [
  {
    location: "au/sydney",
    routes: [
      {
        path: "sydney-wedding-music-red-soda-band",
        name: "Sydney",
      },
      {
        path: "hunter-valley-wedding-music-red-soda-band",
        name: "Hunter Valley",
      },
      {
        path: "southern-highlands-wedding-music-red-soda-band",
        name: "Southern Highlands",
      },
      {
        path: "venues/blue-mountains-wedding-music-red-soda-band",
        name: "Blue Mountains",
      },
    ],
  },
  {
    location: "us/boston",
    routes: [
      {
        path: "locations/new-england-wedding-band",
        name: "New England",
      },
      {
        path: "locations/Connecticut-wedding-band",
        name: "Connecticut",
      },
      {
        path: "locations/boston-wedding-band",
        name: "Boston",
      },
      {
        path: "locations/massachusetts-wedding-band",
        name: "Massachusetts",
      },
      {
        path: "locations/rhode-island-wedding-band",
        name: "Rhode Island",
      },
      {
        path: "locations/new-hampshire-wedding-band",
        name: "New Hampshire",
      },
      {
        path: "locations/vermont-wedding-band",
        name: "Vermont",
      },
      {
        path: "locations/maine-wedding-band",
        name: "Maine",
      },
    ],
  },
  {
    location: "ca/toronto",
    routes: [
      {
        path: "ontario-wedding-band",
        name: "Ontario",
      },
      {
        path: "toronto-wedding-band",
        name: "Toronto",
      },
    ],
  },
]

const listNumberPhone = {
  sydney: {
    numberPhone: "0280062234",
    phoneDisplay: "(02) 8006 2234",
  },
  boston: {
    numberPhone: "6178652929",
    phoneDisplay: "(617) 865 2929",
  },
  toronto: {
    numberPhone: "647694 0999",
    phoneDisplay: "(647) 694 0999",
  },
}

const MobileNav = ({ location, routeParams }) => {
  const [links, setLinks] = useState({})

  useEffect(() => {
    if (location) {
      const existRoutes = locationRoutes.filter(locationRoute =>
        locationRoute.location.includes(location.pathname.split("/")[2])
      )
      setLinks(existRoutes[0])
    }
  }, [location])

  // handle Dropdown
  const [isExpanded, setIsExpanded] = useState(false)
  const dropDown = useRef(null)

  const handleCollapseDropDown = e => {
    setIsExpanded(dropDown.current?.contains(e.target))
  }

  useEffect(() => {
    document.addEventListener("click", handleCollapseDropDown)
    return () => {
      document.removeEventListener("click", handleCollapseDropDown)
    }
  }, [])

  return (
    <>
      <div className="flex flex-row flex-wrap items-center justify-between mb-5">
        <span className="italic pr-7">Your location</span>
        <div className="float-right">
          <LocationSelect location={location} />
        </div>
      </div>
      <div>
        <Link
          to={`/${routeParams?.location}/ceremony/wedding-ceremony-music/`}
          className="flex flex-row items-center justify-between my-5 font-bold"
        >
          CEREMONY MUSIC
          <StaticImage
            alt="angle-right"
            src="../../../static/images/icon/angle-arrow-right-mobile.svg"
          />
        </Link>
        <Link
          to={`/${routeParams?.location}/reception/wedding-reception-music/`}
          className="flex flex-row items-center justify-between my-5 font-bold"
        >
          RECEPTION MUSIC
          <StaticImage
            alt="angle-right"
            src="../../../static/images/icon/angle-arrow-right-mobile.svg"
          />
        </Link>
        <Link
          to={`/${routeParams?.location}/wedding-music-packages/`}
          className="flex flex-row items-center justify-between my-5 font-bold"
        >
          MUSIC PACKAGES
          <StaticImage
            alt="angle-right"
            src="../../../static/images/icon/angle-arrow-right-mobile.svg"
          />
        </Link>
        <Link
          to={`/${routeParams?.location}/wedding-music-videos/`}
          className="flex flex-row items-center justify-between my-5 font-bold"
        >
          MUSIC INSPIRATION
          <StaticImage
            alt="angle-right"
            src="../../../static/images/icon/angle-arrow-right-mobile.svg"
          />
        </Link>
        <Link
          to={`/quote/`}
          className="flex flex-row items-center justify-between my-5 font-bold qbutton"
        >
          GET A QUOTE
          <StaticImage
            alt="angle-right"
            src="../../../static/images/icon/angle-arrow-right-mobile.svg"
          />
        </Link>
        <Link
          to={`/${routeParams?.location}/red-soda-wedding-band${
            routeParams?.location?.includes("boston")
              ? ""
              : "-" + routeParams?.location?.split("/")[1]
          }/`}
          className="my-5 block font-montserrat--14"
        >
          About
        </Link>
        <div
          role="button"
          tabIndex={0}
          className="group relative outline-none"
          onClick={() => setIsExpanded(!isExpanded)}
          onKeyDown={() => setIsExpanded(!isExpanded)}
          ref={dropDown}
        >
          <button className="my-5 block font-montserrat--14">Locations </button>
          <div
            className={`max-w-full border bg-primary rounded w-60 absolute z-10 left-0 top-full transition-all ${
              isExpanded
                ? "visible opacity-100 translate-y-1"
                : "invisible opacity-0"
            }`}
          >
            <ul className="py-1">
              {!!links.routes &&
                links.routes.map(route => {
                  return (
                    <Link
                      to={`/${links.location}/${route.path}`}
                      key={route.name}
                    >
                      <li className="block px-4 py-2 hover:bg-secondary">
                        {route.name}
                      </li>
                    </Link>
                  )
                })}
            </ul>
          </div>
        </div>
        <Link
          to={`/${routeParams?.location}/faq`}
          className="my-5 block font-montserrat--14"
        >
          FAQS
        </Link>
        <Link
          to={`/${routeParams?.location}/blog`}
          className="my-5 block font-montserrat--14"
        >
          Blog
        </Link>
        <Link
          to={`/${routeParams?.location}/contact-red-soda/`}
          className="my-5 block font-montserrat--14"
        >
          Contact
        </Link>
      </div>
      <p className="font-bold text-center pt-8 pb-16">
        <a
          href={`tel:+${
            listNumberPhone[`${routeParams?.location?.split("/")[1]}`]
              ?.numberPhone
          }`}
        >
          TEL :{" "}
          {
            listNumberPhone[`${routeParams?.location?.split("/")[1]}`]
              ?.phoneDisplay
          }
        </a>
      </p>
    </>
  )
}

export default MobileNav
